import styled from "styled-components";
import { Row, Col, Table } from "react-bootstrap";

interface IColWrapped {
    paddingLeft?: number;
}

export const ColWrapper = styled(Col) <IColWrapped>`
    padding-left: ${p => p.paddingLeft ? p.paddingLeft + 'px' : "15px"};
`;

interface IRowWrapped {
    paddingTop?: string,
    paddingBottom?: string
}

export const RowWrapper = styled(Row) <IRowWrapped>`
    padding-bottom: ${p => p.paddingBottom ? p.paddingBottom : "3px"};
`;

interface ITableWrapperProps {
    fontSize?: number
}

export const TableWrapper = styled(Table) <ITableWrapperProps>`
    margin-bottom: 5px;
    
    & > thead > tr > th,
    & > tbody > tr> td {
        font-size: ${p => p.fontSize ? p.fontSize + "px" : "14px"};
        vertical-align: middle;

        select.form-control {
            font-size: 12px !important;
            padding: 3px 2px !important;
        }

        input.form-control {
            font-size: 12px
        }
    }
`;

export const TimezoneValueWrapper = styled.div`
    height: 26px;
    padding: 4px 6px;
    // line-height: 22px;
    font-size: 12px;
    width: 37%;
    margin-left: 3px;
    background-color: #eee;
`;